import styled from 'styled-components'

export const ProgressBarContainer = styled.div`
  width: ${props => props.width};
  height: ${props => props.height};
  background-color: ${props => props.targetColor};
  text-align: left;
`

export const Bar = styled.div`
  height: ${props => props.height};
  background-color: ${props => props.achievedColor};
  width: ${props => `${props.percentageAchieved}%`};
  transition: ${props => `width ${props.animateSeconds} ease-in-out`};
  transition: width 1s ease-in-out;
  display: inline-block;
  vertical-align: top;
`



// WEBPACK FOOTER //
// ./src/component/_presentational/ProgressBar/ProgressBar-styled.js